module.exports = __webpack_public_path__ + "static/media/studio-purchase-trial-modal-bg.7bdc7a31.png";